export const ADMIN_BASE_PATH = "/boshqaruv";
export const ADMIN_LOGIN_PATH = `${ADMIN_BASE_PATH}/login`;

export const STORE_HOME_PATH = "/";
export const STORE_CATALOG_PATH = "/catalog";
export const STORE_CART_PATH = "/savat";
export const LEGACY_STORE_BASE_PATH = "/bozor";

const ADMIN_ROUTE_ORDER = [
  { segment: "dashboard", perm: "Dashboard" },
  { segment: "Sotuv", perm: "Savdo" },
  { segment: "CheklarTarixi", perm: "Savdo" },
  { segment: "Buyurtmalar", perm: "Buyurtmalar" },
  { segment: "BozorTarix", perm: "Buyurtmalar" },
  { segment: "Vozvrat", perm: "Vozvrat" },
  { segment: "Ombor", perm: "Ombor" },
  { segment: "Kassa", perm: "Kassa" },
  { segment: "Hisobkitob", perm: "Hisobkitob" },
  { segment: "accauntlar", perm: "Accauntlar" },
  { segment: "Sotuvchilar", perm: "Mijozlar" },
  { segment: "Maxsulotqosh", perm: "Maxsulotqosh" },
  { segment: "MaxsulotTarix", perm: "MaxsulotTarix" },
  { segment: "Sozlamalar", perm: "Sozlamalar" },
  { segment: "foyda", perm: "Foyda" },
];

function trimSlashes(value = "") {
  return String(value).replace(/^\/+|\/+$/g, "");
}

function canAccessAdminPerm(user, perm) {
  if (!perm) {
    return true;
  }

  const role = String(user?.role || "").toLowerCase();
  const perms = user?.perms || {};
  const anyPermOn = Object.values(perms).some((value) => !!value);

  if (role === "admin") {
    if (!anyPermOn) {
      return true;
    }
    return !perms[perm];
  }

  if (role === "cashier" || role === "seller") {
    if (!anyPermOn) {
      return false;
    }
    return !!perms[perm];
  }

  return false;
}

export function adminPath(path = "") {
  const trimmed = trimSlashes(path);
  return trimmed ? `${ADMIN_BASE_PATH}/${trimmed}` : ADMIN_BASE_PATH;
}

export function legacyStorePath(path = "") {
  const trimmed = trimSlashes(path);
  return trimmed ? `${LEGACY_STORE_BASE_PATH}/${trimmed}` : LEGACY_STORE_BASE_PATH;
}

export function storeProductPath(slug = ":slug") {
  return `/products/${slug}`;
}

export function getAdminFallbackPath(user) {
  const firstAllowedRoute = ADMIN_ROUTE_ORDER.find(({ perm }) =>
    canAccessAdminPerm(user, perm)
  );

  if (firstAllowedRoute) {
    return adminPath(firstAllowedRoute.segment);
  }

  const role = String(user?.role || "").toLowerCase();
  if (role === "seller" || role === "cashier") {
    return adminPath("Sotuv");
  }

  return adminPath("dashboard");
}
